module.exports = __webpack_public_path__ + "img/cross.f53c3ebc.png";